<template>
  <main role="main" class="main bg-navy">
    <div class="bg-navy d-block d-md-none">
      <b-row class="no-gutters">
        <b-col class="text-center">
          <b-button type="button" variant="link" class="color-white float-left py-3" to="/home">
            <feather type="arrow-left"></feather>
          </b-button>
          <span class="d-inline-block h-100 title-w-60">
            <span class="d-table h-100">
              <span class="d-table-cell align-middle">
                <strong class="color-white">Invoicing Details</strong>
              </span>
            </span>
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="mobile-vh min-h-100 p-4 p-md-5 bg-white mobi-rounded-top">
      <b-row class="custom-height">
        <b-col lg="10" offset-lg="1">
          <profile-menu></profile-menu>
          <h2 class="mobile-size-reduce color-navy-blue mb-3">Invoicing Details</h2>
          <b-row class="mb-2 mt-4">
            <b-col md="12" class="pl-lg-0 mb-2 mb-lg-0">
              <maz-checkbox v-model="invoice.enabled">{{ invoice.enabled === true ? 'Disable' : 'Enable' }} invoicing for this company.</maz-checkbox>
              <p class="mt-1 mb-0"><small>
                <b>Note:</b> Invoicing is only available for recurring escrow transactions. Once enabled, Truzo will generate an invoice automatically for every funded recurring transaction and send it both to the buyer and the seller to their verified email addresses. It will also be attached to the transaction itself under "Notes and Attachements".
              </small></p>
            </b-col>
          </b-row>
          <div v-if="invoice.enabled">
            <b-row class="mb-2 mt-4">
              <b-col md="12" class="pl-lg-0 mb-2 mb-lg-0">
                <maz-checkbox v-model="invoice.allow_proforma">{{ invoice.allow_proforma === true ? 'Disable' : 'Enable' }} proforma invoicing for this company.</maz-checkbox>
                <p class="mt-1 mb-0"><small>
                  <b>Note:</b> By default, Truzo will only generate an invoice once the transaction was funded. Once enabled, Truzo will also allow buyers to generate proforma invoices prior to funding - this will create an escrow transaction on the basis of the recurring transaction with implicit approvals of all parties, generate pro-forma invoice, attach it to the transaction and allow the user to download it before making a payment.
                </small></p>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6" class="pl-lg-0 mb-2 mb-lg-0">
                <maz-input v-model="invoice.invoice_numbers" placeholder="Starting number for the invoices" required :success="invoice.invoice_numbers && invoice.invoice_numbers > 0"></maz-input>
              </b-col>
              <b-col md="6" class="pl-lg-0">
                <b-form-file v-model="invoice.logo">
                  <template slot="file-name" slot-scope="{ names }">
                    <b-badge class="mr-1" variant="dark" v-for="(name, $index) in names" :key="$index">{{ name }}</b-badge>
                  </template>
                </b-form-file>
                <small v-if="invoice.logo === null || invoice.logo === undefined || invoice.logo.length === 0" class="ml-2 mt-3 form-text text-muted">Choose a file or drop it here</small>
                <small v-if="invoice.logo && invoice.logo.length >= 1" class="ml-2 mt-3 form-text"><a href="#" @click.prevent="invoice.logo = null">
                  <feather type="trash-2" size="14px"></feather>
                  Reset file selection
                </a></small>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="12" class="pl-lg-0 mb-2 mb-lg-0">
                <maz-input v-model="invoice.invoice_note" required clearable textarea placeholder="Invoice footer notes" :success="invoice.invoice_note && invoice.invoice_note >= 2 && invoice.invoice_note <= 300" :error="invoice.invoice_note && invoice.invoice_note > 300"></maz-input>
                <p class="mt-1 mb-0"><small>
                  <b>Note:</b> A maximum of 4 lines or 300 characters are allowed in the notes for the best presentation on the invoice.
                </small></p>
              </b-col>
            </b-row>
            <b-row class="mb-2 mt-4">
              <b-col md="12" class="pl-lg-0 mb-2 mb-lg-0">
                <maz-checkbox v-model="invoice.request_txn_note">{{ invoice.request_txn_note === true ? 'Disable' : 'Enable' }} requesting transaction notes for this company.</maz-checkbox>
                <p class="mt-1 mb-0"><small>
                  <b>Note:</b> By default, Truzo will not ask the buyer to add any additional notes to the transaction once it has been funded. If enabled, Truzo will prompt the user to add notes to the transaction for the seller; prompt text can be changed below.
                </small></p>
              </b-col>
            </b-row>
            <b-row class="mb-2" v-if="invoice.request_txn_note">
              <b-col md="12" class="pl-lg-0 mb-2 mb-lg-0">
                <maz-input v-model="invoice.txn_note" clearable textarea placeholder="Additional notes request prompt"></maz-input>
              </b-col>
            </b-row>
            <b-row v-if="currentLogo">
              <b-col offset-md="5" md="2" class="pl-lg-0 mb-2 mb-lg-0 mt-4 text-center">
                <h6 class="mb-1">Current Logo</h6>
                <img :src="currentLogo.path" class="img img-fluid" />
              </b-col>
            </b-row>
          </div>

          <!-- <b-row class="mb-2">
            <b-col md="6" class="pl-lg-0">
              <maz_input v-model="company.phone" placeholder="Office number" :success="company.phone && company.phone >= 2"></maz_input>
            </b-col>
          </b-row> -->

          <b-row>
            <b-form-group class="col-xl-12 btn-bottom px-md-0">
              <b-row>
                <b-col lg="6" offset-lg="6" cols="12">
                  <loading-button :replace="saving === true">
                    <b-button variant="custom"  @click="save()" pill block class="mt-3" :disabled="!canSave">Save</b-button>
                  </loading-button>
                </b-col>
              </b-row>
            </b-form-group>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
import ProfileMenu from '@/components/organisation/ProfileMenu'
import { mapState, mapActions } from 'vuex'

import { companyService } from '@/services'

export default {
  components: {
    ProfileMenu
  },
  data () {
    return {
      saving: false,
      company: {
        company_type: null,
        name: null,
        trading_name: null,
        reg_number: null,
        vat_number: null,
        address: null,
        trading_address: null,
        country: 'ZA',
        status: 'In Business',
        industry: null,
        phone: null,
        email: null,
        website: null
      },
      invoice: {
        enabled: false,
        allow_proforma: false,
        invoice_numbers: null,
        logo: null,
        current_logo: null,
        invoice_note: null,
        request_txn_note: false,
        txn_note: null
      },
      company_schema: {
        fields: [
          {
            type: 'select',
            placeholder: 'Company Type',
            model: 'company_type',
            values: (model, schema) => {
              const _companies = []
              this.businessStore.Types.forEach(type => {
                _companies.push({ id: type, name: type })
              })
              return _companies
            },
            selectOptions: {
              noneSelectedText: 'Company type',
              hideNoneSelectedText: false
            },
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Company Name',
            model: 'name',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Registration Number',
            model: 'reg_number',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Tax / VAT Number',
            model: 'vat_number',
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Operating / Trading Name',
            model: 'trading_name',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'select',
            placeholder: 'Country of Establishment',
            model: 'country',
            values: (model, schema) => {
              const _countries = []
              this.countries.forEach(country => {
                _countries.push({ id: country.code, name: country.name })
              })
              return _countries
            },
            required: true,
            selectOptions: {
              noneSelectedText: 'Country of Establishment',
              hideNoneSelectedText: false
            },
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'select',
            placeholder: 'Business Status',
            model: 'status',
            values: (model, schema) => {
              const _companies = []
              this.businessStore.Statuses.forEach(type => {
                _companies.push({ id: type, name: type })
              })
              return _companies
            },
            selectOptions: {
              noneSelectedText: 'Business status',
              hideNoneSelectedText: false
            },
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'select',
            placeholder: 'Industry',
            model: 'industry',
            values: (model, schema) => {
              const _industries = []
              this.industries.forEach(industry => {
                _industries.push(industry)
              })
              return _industries
            },
            required: true,
            validator: ['required'],
            selectOptions: {
              noneSelectedText: 'Industry',
              hideNoneSelectedText: false
            },
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Registered Address',
            model: 'address',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Operating / Trading Address',
            model: 'trading_address',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'input',
            inputType: 'email',
            placeholder: 'Email Address',
            model: 'email',
            validator: ['email'],
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Website Address',
            model: 'website',
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          },
          {
            type: 'tel-input',
            label: 'Office number',
            placeholder: 'Office Number',
            model: 'phone',
            validator: ['telNumber'],
            styleClasses: 'col-12 col-xl-6 pl-lg-0'
          }
        ]
      },
      formOptions: {
        validationErrorClass: 'has-error',
        validationSuccessClass: 'has-success',
        validateAfterChanged: false,
        validateAsync: true
      },
      action: null,
      data: null
    }
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      auth: state => state.auth.user,
      businessStore: state => state.business,
      countries: state => state.country.countries,
      industries: state => state.industries.industry,
      companies: state => state.company
    }),
    companyLoaded () {
      return this.companies.status
    },
    myRole () {
      if (this.auth && this.auth.user && this.auth.user.role) {
        return this.auth.user.role.name
      } else {
        return 'Unknown'
      }
    },
    canSave () {
      if (this.myRole !== 'Administrators') {
        return false
      } else {
        if (this.invoice.enabled) {
          if (this.invoice.invoice_numbers && (this.invoice.invoice_note && this.invoice.invoice_note.length >= 2 && this.invoice.invoice_note.length <= 300)) {
            if (this.invoice.logo) {
              return true
            } else {
              if (this.invoice.current_logo) {
                return true
              } else {
                return false
              }
            }
          } else {
            return false
          }
        } else {
          return true
        }
      }
    },
    currentLogo () {
      if (this.companyLoaded === 'loaded' && this.invoice.current_logo) {
        const _company = this.companies.company
        const _logo = _company.attachments.find(a => a._id === this.invoice.current_logo)

        return _logo
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions('alert', {
      setError: 'error'
    }),
    ...mapActions('company', {
      getCompany: 'get',
      saveCompany: 'save'
    }),
    loadFile: async function (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        reader.onload = (e) => {
          resolve(e.target.result)
        }
        reader.onerror = (e) => {
          reject(e)
        }
        reader.readAsDataURL(file)
      })
    },
    save: async function () {
      this.saving = true

      const _payload = JSON.parse(JSON.stringify(this.company))
      _payload.invoice = JSON.parse(JSON.stringify(this.invoice))
      try {
        _payload.invoice.invoice_numbers = parseInt(this.invoice.invoice_numbers.trim())

        if (!isNaN(_payload.invoice.invoice_numbers)) {
          if (this.invoice.logo) {
            const _file = await this.loadFile(this.invoice.logo)
            const _mime = _file.substr(_file.indexOf('data:') + 5, _file.indexOf(';base64,') - 5)
            console.log(_mime)

            if (_mime.indexOf('jpg') >= 0 || _mime.indexOf('jpeg') >= 0 || _mime.indexOf('png') >= 0) {
              const __file = _file.substr(_file.indexOf(';base64,') + 8)

              const _result = await companyService.attach([{
                name: this.invoice.logo.name,
                type: 'Logo',
                mime_type: _mime,
                attachment: __file
              }])

              if (_result && _result._id) {
                _payload.invoice.logo = _result._id
                this.saveCompany(_payload)
              } else {
                this.saving = false
                this.setError('Could not upload logo file! Please, try attaching the logo again then saving ...')
              }
            } else {
              this.saving = false
              this.setError('Logo must be a JPG or PNG image file!')
            }
          } else {
            _payload.invoice.logo = this.invoice.current_logo
            this.saveCompany(_payload)
          }
        } else {
          this.saving = false
          this.setError('Starting number for the invoices must be a number!')
        }
      } catch (e) {
        this.saving = false
        console.log(e)
        this.setError('There was an error saving invoicing details! Please, review and try saving again ...')
      }
    }
  },
  mounted () {
    this.getCompany()
  },
  watch: {
    companyLoaded (value) {
      if (value === 'loaded') {
        this.saving = false
        const _company = this.companies.company
        if (_company.phone && _company.phone.charAt(0) === '0') {
          _company.phone = '+27' + _company.phone.substr(1)
        }

        this.company = {
          company_type: _company.company_type,
          name: _company.name,
          trading_name: _company.trading_name,
          reg_number: _company.reg_number,
          vat_number: _company.vat_number,
          address: _company.address,
          trading_address: _company.trading_address,
          country: _company.country || 'ZA',
          status: _company.status || 'In Business',
          industry: _company.industry,
          phone: _company.phone,
          email: _company.email,
          website: _company.website
        }

        this.invoice = {
          enabled: _company.invoice.enabled,
          allow_proforma: _company.invoice.allow_proforma,
          invoice_numbers: _company.invoice.invoice_numbers.toString(),
          logo: null,
          current_logo: _company.invoice.logo,
          invoice_note: _company.invoice.invoice_note,
          request_txn_note: _company.invoice.request_txn_note,
          txn_note: _company.invoice.txn_note
        }
      }

      if (value === 'saved') {
        this.getCompany()
      }
    }
  }
}
</script>
